import { itemImages } from './itemImages';

/**
 * A arte de uma coisa do catálogo do pedido de apetrecho do clã.
 *
 * O servidor manda `imagem` a partir de `image_media_id`, e isso cobre poção,
 * material, apetrecho e item de explorador — que nasceram com a arte no banco.
 * **Isca e vara não**: as 4 iscas e as 14 varas têm `image_media_id` nulo, e a
 * arte delas mora no cliente, em `itemImages.js`, que é de onde a loja e o
 * inventário sempre a tiraram (`bruto.image || getItemImage(bruto.name)`). Sem
 * esta queda, toda isca e toda vara do varal saíam com o ícone de reserva
 * (`box`, o balde) — e isca e vara são o que mais se pede.
 *
 * A arte do servidor vence: no dia em que alguém subir a arte da vara pelo
 * painel, ela aparece sem mexer aqui. E usa `itemImages[nome]`, não
 * `getItemImage`: nome desconhecido fica `null`, para a tela desenhar o ícone
 * do tipo em vez do `default-item.svg`.
 */
const ARTE_NO_CLIENTE = ['bait', 'rod'];

export function comArte(tipo, alvo) {
  if (!alvo || alvo.imagem || !ARTE_NO_CLIENTE.includes(tipo)) return alvo;
  return { ...alvo, imagem: itemImages[alvo.nome] || null };
}

/** Os seis catálogos do formulário, com a arte de isca e vara preenchida. */
export function catalogoComArte(catalogo) {
  if (!catalogo) return catalogo;
  return Object.fromEntries(
    Object.entries(catalogo).map(([tipo, lista]) => [
      tipo,
      Array.isArray(lista) ? lista.map((alvo) => comArte(tipo, alvo)) : lista,
    ]),
  );
}

/** A lista de pedidos, com a arte de isca e vara preenchida em cada linha. */
export function pedidosComArte(pedidos) {
  return (pedidos || []).map((pedido) => ({
    ...pedido,
    itens: (pedido.itens || []).map((coisa) => ({ ...coisa, alvo: comArte(coisa.tipo, coisa.alvo) })),
  }));
}
